import { action } from 'lib/actions';

export const onFieldChangeAction = action('cardForm/FIELD_CHANGE');
export const onFieldBlurAction = action('cardForm/FIELD_BLUR');
export const onFieldErrorAction = action('cardForm/FIELD_ERROR');
export const resetCardFormAction = action('cardForm/RESET');
export const setStripeCardTokenAction = action('cardForm/SET_TOKEN');
export const setStripeCardTokenInvalidAction = action('cardForm/SET_TOKEN_INVALID');
